module.exports = __webpack_public_path__ + "static/media/x-logo-white.1092570c.png";